import { render, staticRenderFns } from "./FamilyManage.vue?vue&type=template&id=3ca7a736&scoped=true"
import script from "./FamilyManage.vue?vue&type=script&lang=js"
export * from "./FamilyManage.vue?vue&type=script&lang=js"
import style0 from "./FamilyManage.vue?vue&type=style&index=0&id=3ca7a736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7a736",
  null
  
)

export default component.exports